import { motion, AnimatePresence } from 'framer-motion';
import { useScrollReveal } from '../hooks/useScrollReveal';
import { fadeInUp, staggerContainer, subtleHover, pageTransition, cardStagger } from '../utils/animations';
import { Link } from 'react-router-dom';
import { ArrowRight, ChevronLeft, ChevronRight } from 'lucide-react';
import { useState } from 'react';

const Projects = () => {
  const { ref, controls } = useScrollReveal();
  const [currentPage, setCurrentPage] = useState(0);
  const projectsPerPage = 6; // 한 페이지에 6개 프로젝트 표시

  const projects = [
    { id: 1, slug: 'snapfund', title: 'SnapFund', description: '개발자 후원 중개 플랫폼이에요. 손 쉽게 후원을 받아보세요!', tags: ['Node.js', 'React.js', 'SQLite3', 'Figma'] },
    { id: 2, slug: 'study-together', title: '지금 이 시간, 이 자리', description: '공부 친구로 이 웹사이트를 사용해 보세요!', tags: ['Node.js', 'TailwindCSS', 'React.js'] },
    { id: 3, slug: 'loggly', title: '새로운 블로그, Loggly', description: '일상을 한번 적어볼까요?', tags: ["Node.js", "TailwindCSS", "React.js"] },
    { id: 4, slug: 'kakaobot-haribot', title: '카카오톡 봇, 하리봇', description: '카카오톡 어디에서나 사용이 가능한 봇이에요!', tags: ["Python", "SQLite3", "Android ADB"] },
    { id: 5, slug: 'discordbot-haribot', title: '디스코드 봇, 하리봇', description: '디스코드에서 유용한 유틸리티와 게임을 만나보세요!', tags: ["Discord.py", "Python", "SQLite3"] },
    { id: 6, slug: 'vancord', title: '커뮤니티를 안전하게, Vancord', description: 'Vancord는 디스코드 커뮤니티를 더욱 안전하게 만들어주는 팀이에요!', tags: ["SQLite3", "Discord.py", "Python"] },
    { id: 7, slug: 'servermanager', title: '서버 로더, ServerManager', description: '새로 강화된 마인크래프트의 서버 로더를 제작하고 있어요!', tags: ['Node.js', 'React.js', 'Docker'] },
    { id: 8, slug: 'poker-chip-calc', title: '포커 칩 계산기', description: '손쉽게 포커 칩 개수를 계산해 보세요!', tags: ['Python'] },
    { id: 9, slug: 'insta-pingpong', title: '인스타그램 핑퐁', description: '인스타그램에 있는 미니게임인 핑퐁을 자동으로 깨줘요!', tags: ['Python', 'Android ADB'] },
    { id: 10, slug: 'youtube-summary', title: '유튜브 영상 요약', description: 'AI가 신속하고 정확하게 영상을 요약하고, 정확한 타임라인을 생성해줘요!', tags: ['Python', 'React.js', 'TailwindCSS'] },
    { id: 11, slug: 'zeumwiki', title: '새로운 방식의 위키, 지음위키', description: '지음위키는 AI가 직접 객관적으로 여러 출처를 꼼꼼히 참고해서 위키를 제작해요!', tags: ['Python', 'Node.js', 'React.js', 'SQLite3', 'TailwindCSS'] },
    { id: 12, slug: 'pymusisync', title: '음악 자막 모듈, pyMusicSync', description: 'pyMusicSync는 노래 제목을 입력하면 해당 노래의 가사를 가져와줘요!', tags: ['Python'] },
    { id: 13, slug: 'dLLM', title: 'Diffusion을 활용한 언어 모델', description: 'Diffusion 기술을 LLM에 접목하는 연구를 진행하고 있어요!', tags: ['Python', 'AI', 'LLM'] },
    { id: 14, slug: 'autoDrive', title: '자율주행모델 제작', description: 'Carla와 자기강화학습을 이용해 자율주행모델을 학습시켜봤어요.', tags: ['Python', 'Carla'] },
    { id: 15, slug: 'nvtoon-cli', title: 'nvtoon-cli', description: '네이버 웹툰에 대한 정보를 불러오는 CLI에요.', tags: ['Node.js'] },
    { id: 16, slug: 'nvtoon-gui', title: 'nvtoon-gui', description: 'nvtoon-cli를 개선시킨 GUI 프로그램이에요. 다양한 편리 기능이 추가되어 있어요.', tags: ['Node.js', 'Electron'] },
    { id: 17, slug: 'ARCHITECTURE', title: '현실경제와 국가전쟁의 조화, ARCHITECTURE', description: '현실경제와 국가전쟁을 합친 서버 ARCHITECTURE에서 팀장을 맡고 있어요.', tags: ['Minecraft', 'Kotlin'] },
    { id: 18, slug: 'GameStats-MCP', title: 'GameStats - AI에게 게임 전적 도구를 제공하세요', description: 'PlayMCP 출전을 위해 MCP 서버를 제작했어요.', tags: ['MCP', 'Node.js', 'Anthropic', 'Kakao'] },
    { id: 19, slug: 'StockAuto', title: 'StockAuto - AI 주식 매매 프로그램', description: 'AI를 이용해서 주식 매매/매도를 자동으로 진행해 보세요.', tags: ['Node.js', 'React.js', "AI"] },
    { id: 20, slug: 'toss-same-cat', title: '토스 같은 그림 찾기 자동화', description: '유사도와 ADB를 이용해서, 토스 고양이 맞추기 이벤트 자동화 프로그램을 제작했어요.', tags: ['Python', 'Android ADB'] },
    { id: 21, slug: 'yt-unsubscribe', title: '유튜브 구독 취소 자동화', description: 'GUI로 제공되는 프로그램으로 손쉽게 필요 없는 채널을 일괄로 구독 취소해 보세요.', tags: ['Python', 'PyQt', "Youtube Data API v3"] },
    { id: 22, slug: 'AutoCTF', title: '문제 풀이 자동화 - AutoCTF', description: 'CTF 문제를 풀이하느라 귀찮으셨죠? 이제 자동입니다!', tags: ['Node.js', 'Electron', "React.js", "Docker", "AI"] },
    { id: 23, slug: 'Tunex', title: 'Tunex - 여러 노래 플랫폼을 한 곳에서', description: '여러 노래 플랫폼을 이용하느라 힘드셨나요? 이제는 한 플랫폼에서 확인해 보세요!', tags: ['Node.js', 'Electron', "React.js", "Docker", "React Native"] },
    { id: 24, slug: 'KakaoForge', title: 'KakaoForge', description: '카카오톡 봇 개발자들이 사용할 수 있는 봇 라이브러리를 개발중이에요.', tags: ['Node.js', 'Kakao', 'Reversing'] },
    { id: 25, slug: 'Sunrin-Server', title: '선린인고 서버', description: '선린인분들이 들어와 즐길 수 있는 서버입니다.', tags: ['Minecraft', 'Java', 'SRIHS'] },
    { id: 26, slug: 'sunrin-club', title: '선린인고 커뮤니티 - 선린모여라', description: '선린인고 졸업생, 재학생이 이용할 수 있는 커뮤니티를 운영중이에요. 선린인고 관련 중요 정보를 받아보세요.', tags: ['Discord', "SRIHS"] },
    { id: 27, slug: 'sunrin-club-bot', title: '선린모여라 (봇)', description: '선린모여라에서 사용할 수 있는 봇을 제작했어요.', tags: ['Discord.js', "SRIHS"] },
    { id: 28, slug: 'Sunrin-Server-Plugin', title: '선린인고 서버 플러그인', description: '선린인고 서버만을 위한 플러그인을 제작했어요.', tags: ["Minecraft", "Kotlin", 'SRIHS'] },
    { id: 29, slug: 'Sunrin-Server-Page', title: '선린인고 서버 페이지', description: '마인크래프트와 닮게 선린인고 서버 상태를 확인할 수 있는 페이지를 제작했어요.', tags: ["Minecraft", "React.js", "Node.js", 'SRIHS'] },
    { id: 30, slug: 'Quilt', title: '팀을 위한 문서 관리 시스템', description: '팀 또는 회사를 위한 내부 문서 관리 시스템을 개발하고 있어요.', tags: ['Node.js', 'React.js'] },
    { id: 31, slug: 'Gitfle', title: 'Gitfle, 자신의 평소 코딩 습관을 진단 받아 보세요', description: 'AI Agent가 Git 내용을 통해 본인의 평소 습관, 장단점, 보안할 점, 포트폴리오 등을 분석해 줘요!', tags: ['Hackathon', 'React.js', 'Node.js', "OpenAI"] },
    { id: 32, slug: 'OpenRoute', title: 'OpenRoute, 접근성 정보 지도에 기여해 보세요', description: 'OpenRoute에서 지체장애인을 위한 접근성 정보를 등록하고, 지도로 쉽게 확인할 수 있어요!', tags: ['Hackathon', 'React.js', 'Node.js', "OpenAI"] },
  ];

  // 페이지네이션 계산
  const totalPages = Math.ceil(projects.length / projectsPerPage);
  const startIndex = currentPage * projectsPerPage;
  const endIndex = startIndex + projectsPerPage;
  const currentProjects = projects.slice(startIndex, endIndex);

  const handlePreviousPage = () => {
    setCurrentPage(prev => prev === 0 ? totalPages - 1 : prev - 1);
  };

  const handleNextPage = () => {
    setCurrentPage(prev => prev === totalPages - 1 ? 0 : prev + 1);
  };

  return (
    <section id="projects" className="py-20 bg-white group">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <motion.div
          ref={ref}
          initial="initial"
          animate={controls}
          variants={fadeInUp}
          className="text-center mb-16"
        >
          <h2 className="text-3xl sm:text-4xl font-bold text-neutral-800">
            Projects
          </h2>
        </motion.div>

        {/* Projects Grid with Pagination */}
        <div className="relative">
          {/* Left Arrow */}
          <button
            onClick={handlePreviousPage}
            className="absolute left-0 top-1/2 -translate-y-1/2 -translate-x-28 z-10 p-3 rounded-full shadow-lg transition-all duration-300 opacity-0 group-hover:opacity-100 bg-white text-neutral-600 hover:bg-primary-50 hover:text-primary-600 hover:shadow-xl cursor-pointer "
            aria-label="이전 페이지"
          >
            <ChevronLeft className="w-6 h-6" />
          </button>

          {/* Right Arrow */}
          <button
            onClick={handleNextPage}
            className="absolute right-0 top-1/2 -translate-y-1/2 translate-x-28 z-10 p-3 rounded-full shadow-lg transition-all duration-300 opacity-0 group-hover:opacity-100 bg-white text-neutral-600 hover:bg-primary-50 hover:text-primary-600 hover:shadow-xl cursor-pointer"
            aria-label="다음 페이지"
          >
            <ChevronRight className="w-6 h-6" />
          </button>

          <div className="relative">
            <AnimatePresence mode="wait">
              <motion.div
                key={currentPage}
                variants={pageTransition}
                initial="initial"
                animate="animate"
                exit="exit"
                className="grid md:grid-cols-2 lg:grid-cols-3 gap-8"
              >
                <motion.div
                  variants={cardStagger}
                  initial="initial"
                  animate="animate"
                  className="contents"
                >
                  {currentProjects.map((project, index) => (
                    <Link key={project.id} to={`/projects/${project.slug}`} className="block">
                      <motion.div
                        variants={fadeInUp}
                        whileHover={subtleHover.whileHover}
                        className="bg-white rounded-2xl p-6 shadow-sm hover:shadow-xl transition-all duration-300 border border-neutral-100 cursor-pointer project-card-group h-full"
                      >
                        <div className="flex justify-between items-start mb-2">
                          <h3 className="text-xl font-bold text-neutral-800 transition-colors project-card-title">
                            {project.title}
                          </h3>
                        </div>
                        <p className="text-neutral-600 mb-4 line-clamp-2">
                          {project.description}
                        </p>
                        <div className="flex flex-wrap gap-2">
                          {project.tags.map((t) => (
                            <span key={t} className="px-3 py-1 bg-neutral-100 text-neutral-700 text-sm rounded-full">
                              {t}
                            </span>
                          ))}
                        </div>
                      </motion.div>
                    </Link>
                  ))}
                </motion.div>
              </motion.div>
            </AnimatePresence>
          </div>
        </div>

        {/* Page Indicator */}
        <div className="flex justify-center items-center mt-12 space-x-2">
          {Array.from({ length: totalPages }, (_, index) => (
            <button
              key={index}
              onClick={() => setCurrentPage(index)}
              className={`w-3 h-3 rounded-full transition-all duration-300 ${
                index === currentPage 
                  ? 'bg-primary-600 scale-125' 
                  : 'bg-neutral-300 hover:bg-neutral-400'
              }`}
              aria-label={`페이지 ${index + 1}`}
            />
          ))}
        </div>
      </div>
    </section>
  );
};

export default Projects;
